<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><i>CONTENTS</i></span></p>
<p class="toc-text"><span><a href="#/xhtml/fm01"><i>Introduction</i> by David Fisher</a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter001"><b><i>1</i></b> Joey—What You’d Call My Early Years</a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter002"><b><i>2</i></b> The Gang’s All Here</a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample"><b><i>3</i></b> The Numbers</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample"><b><i>4</i></b> The Process of Elimination</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample"><b><i>5</i></b> The Shy’s the Limit</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample"><b><i>6</i></b> The Business of Pleasure</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample"><b><i>7</i></b> Bettors, Bookies and Bookmaking</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample"><b><i>8</i></b> Horses and Other Athletes</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample"><b><i>9</i></b> Big Deal</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample"><b><i>10</i></b> Some of Our Best Friends Are in Show Biz</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample"><b><i>11</i></b> The Cost of Highs</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter012" title="Link target outside of Sample"><b><i>12</i></b> I Can Get It for You No Sale</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter013" title="Link target outside of Sample"><i><b>13</b> The Godfather:</i> The Way Things Ain’t</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter014" title="Link target outside of Sample"><b><i>14</i></b> Gallo and Colombo: The Way Things Are</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter015" title="Link target outside of Sample"><b><i>15</i></b> Doing Business with Cops and Pols</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter016" title="Link target outside of Sample"><b><i>16</i></b> Fences</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter017" title="Link target outside of Sample"><b><i>17</i></b> Going Legit</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter018" title="Link target outside of Sample"><b><i>18</i></b> The Graybar Hotel</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter019" title="Link target outside of Sample"><b><i>19</i></b> Good-bye</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample"><i>Epilogue</i> by David Fisher</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter02" title="Link target outside of Sample"><i>About the Authors</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?be181d0e